import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { stStatusOptions } from "../../../static/dropdown";
import dayjs from "dayjs";

const VisaTable = ({
  visaReportStatusWise,
  visaReportStatusWiseLoading,
  visaReportWise,
  visaReportStatusLoading,
  baReport,
  baLoading,
  uniWiseport = [],
  uniWiseLoading,
}) => {
  const hasVisaReportStatusWiseData =
    visaReportStatusWise &&
    typeof visaReportStatusWise === "object" &&
    Object.keys(visaReportStatusWise).length > 0;

  const visaStatusData = visaReportStatusWise?.resultArray;

  const hasUniWiseData = Array.isArray(uniWiseport) && uniWiseport.length > 0;

  const hasVisaReportData =
    visaReportWise &&
    typeof visaReportWise === "object" &&
    Object.keys(visaReportWise).length > 0;
  const hasBaData =
    baReport &&
    typeof baReport === "object" &&
    Object.keys(baReport).length > 0;

  const getStudentStatus = (code) => {
    const res = stStatusOptions.find((item) => item.value === parseInt(code));
    return res.label;
  };

  return (
    <div className="">
      {!visaReportStatusWiseLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Status Wise Visa Reports
                </span>
              </div>
              <div
                className="py-2"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasVisaReportStatusWiseData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="">
                      <tr className="text-center text-nowrap">
                        <th>Status</th>
                        <th>Total</th>
                        {visaStatusData?.map((item, idx) => (
                          <th key={idx}>{getStudentStatus(item.STSTATUS)}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        <td>{visaReportStatusWise?.totalStudents?.count}</td>
                        {visaStatusData?.map((item, idx) => (
                          <td key={idx} className="text-center">
                            {item.STATUS}
                          </td>
                        ))}
                      </tr>
                      <tr className="text-nowrap">
                        <th>Visa Package Count</th>
                        <td>{visaReportStatusWise?.visaPackage?.count}</td>
                        {visaStatusData?.map((item, idx) => (
                          <td key={idx} className="text-center">
                            {item.VISAPACKAGE}
                          </td>
                        ))}
                      </tr>
                      <tr className="text-nowrap">
                        <th>Visa Process Started & Above</th>
                        <td>
                          {visaReportStatusWise?.visaProcessStarted?.count}
                        </td>
                        {visaStatusData?.map((item, idx) => (
                          <td key={idx} className="text-center">
                            {item.VISAPROCESSSTARTED}
                          </td>
                        ))}
                      </tr>
                      <tr className="text-nowrap">
                        <th>Bachelor</th>
                        <td>
                          {visaReportStatusWise?.visaProcessBachelor?.count}
                        </td>
                        {visaStatusData?.map((item, idx) => (
                          <td key={idx} className="text-center">
                            {item.BACHELOR}
                          </td>
                        ))}
                      </tr>
                      <tr className="text-nowrap">
                        <th>Master's</th>
                        <td>
                          {visaReportStatusWise?.visaProcessMaster?.count}
                        </td>
                        {visaStatusData?.map((item, idx) => (
                          <td key={idx} className="text-center">
                            {item.MASTER}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!visaReportStatusLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">Visa Reports</span>
              </div>
              <div
                className="py-2"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasVisaReportData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Updated</th>
                        <th>Not Updated</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Visa SOP Completed</th>
                        <td>{visaReportWise?.visaSopFinal?.count}</td>
                        <td>{visaReportWise?.visaSopFinalNull?.count}</td>
                      </tr>
                      <tr>
                        <th>Visa SOP Uploaded</th>
                        <td>{visaReportWise?.visaSopUploaded?.count}</td>
                        <td>{visaReportWise?.visaSopUploadedNull?.count}</td>
                      </tr>
                      <tr>
                        <th>Passport Copy Uploaded</th>
                        <td>{visaReportWise?.passportUploaded?.count}</td>
                        <td>{visaReportWise?.passportNotUploaded?.count}</td>
                      </tr>
                      <tr>
                        <th>APS Recieved</th>
                        <td>{visaReportWise?.apsRecieved?.count}</td>
                        <td>{visaReportWise?.apsRecievedNull?.count}</td>
                      </tr>
                      <tr>
                        <th>APS Upload</th>
                        <td>{visaReportWise?.apsUploaded?.count}</td>
                        <td>{visaReportWise?.apsNotUploaded?.count}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!visaReportStatusLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">Admission Status</span>
              </div>
              <div
                className="py-2"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasVisaReportData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr>
                        <th>Admission Status</th>
                        <th>Total</th>
                        <th>Public</th>
                        <th>Private</th>
                        <th>Other</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Final Accepted</th>
                        <td>{visaReportWise?.finalAccepted?.count}</td>
                        <td>{visaReportWise?.finalAcceptedPublic?.count}</td>
                        <td>{visaReportWise?.finalAcceptedPrivate?.count}</td>
                        <td>{visaReportWise?.finalAcceptedOther?.count}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!baLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="row">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Status Wise Reports
                </span>
              </div>
              <div
                className="py-2 col-md-4"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasBaData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr>
                        <th>BA Status</th>
                        <th>Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>BA Not Started</th>
                        <td>{baReport?.baNotStarted?.count}</td>
                      </tr>
                      <tr>
                        <th>BA Intro done</th>
                        <td>{baReport?.baIntroDone?.count}</td>
                      </tr>
                      <tr>
                        <th>BA Opened</th>
                        <td>{baReport?.baOpened?.count}</td>
                      </tr>
                      <tr>
                        <th>Fund Transferres</th>
                        <td>{baReport?.fundTransferred?.count}</td>
                      </tr>
                      <tr>
                        <th>Not Updated</th>
                        <td>{baReport?.notUpdate?.count}</td>
                      </tr>
                      <tr>
                        <th>Not Applicable</th>
                        <td>{baReport?.notApplicable?.count}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
              <div
                className="py-2 col-md-4"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasBaData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr>
                        <th>Visa Process Status</th>
                        <th>Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Visa Process not Started</th>
                        <td>{baReport?.visaProcessNotStarted?.count}</td>
                      </tr>
                      <tr>
                        <th>Checklist Sent</th>
                        <td>{baReport?.checklistSent?.count}</td>
                      </tr>
                      <tr>
                        <th>Email/Call Done</th>
                        <td>{baReport?.callDone?.count}</td>
                      </tr>
                      <tr>
                        <th>Document Preoared</th>
                        <td>{baReport?.docPrepared?.count}</td>
                      </tr>
                      <tr>
                        <th>Document Sent</th>
                        <td>{baReport?.docSent?.count}</td>
                      </tr>
                      <tr>
                        <th>Document Verified & Sent</th>
                        <td>{baReport?.docSent?.count}</td>
                      </tr>
                      <tr>
                        <th>Mock One Done</th>
                        <td>{baReport?.mockOneDone?.count}</td>
                      </tr>
                      <tr>
                        <th>Mock Two Done</th>
                        <td>{baReport?.mockTwoDone?.count}</td>
                      </tr>
                      <tr>
                        <th>Financials Recieved</th>
                        <td>{baReport?.finRecieved?.count}</td>
                      </tr>
                      <tr>
                        <th>Not Applicable</th>
                        <td>{baReport?.notApplicableVisa?.count}</td>
                      </tr>
                      <tr>
                        <th>Not Update</th>
                        <td>{baReport?.notUpdatedVisa?.count}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
              <div
                className="py-2 col-md-4"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasBaData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr>
                        <th>Visa File Status</th>
                        <th>Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Applied</th>
                        <td>{baReport?.applied?.count}</td>
                      </tr>
                      <tr>
                        <th>To Be Re-applied</th>
                        <td>{baReport?.reApplied?.count}</td>
                      </tr>
                      <tr>
                        <th>To Be Re-filled</th>
                        <td>{baReport?.toFilled?.count}</td>
                      </tr>
                      <tr>
                        <th>Partially Filled</th>
                        <td>{baReport?.partiallyFilled?.count}</td>
                      </tr>
                      <tr>
                        <th>Under Review</th>
                        <td>{baReport?.underReview?.count}</td>
                      </tr>
                      <tr>
                        <th>Appointment Booked</th>
                        <td>{baReport?.appointmentBooked?.count}</td>
                      </tr>
                      <tr>
                        <th>Appointment Not Booked</th>
                        <td>{baReport?.appointmentNotBooked?.count}</td>
                      </tr>
                      <tr>
                        <th>To Be Launched</th>
                        <td>{baReport?.toLaunch?.count}</td>
                      </tr>
                      <tr>
                        <th>Waitlisted</th>
                        <td>{baReport?.waitlisted?.count}</td>
                      </tr>
                      <tr>
                        <th>Stamped</th>
                        <td>{baReport?.stamped?.count}</td>
                      </tr>
                      <tr>
                        <th>Submitted</th>
                        <td>{baReport?.submitted?.count}</td>
                      </tr>
                      <tr>
                        <th>Rejected</th>
                        <td>{baReport?.rejected?.count}</td>
                      </tr>
                      <tr>
                        <th>Pending</th>
                        <td>{baReport?.pendingFileStatus?.count}</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!uniWiseLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="">
              <div className="">
                <span className="fs-5 fw-bold text-dark">
                  Visa Appoinments Reports
                </span>
              </div>
              <div
                className="py-2"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                {hasUniWiseData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="sticky-top">
                      <tr className="text-nowrap">
                        <th>Visa Assignment Upcoming Date</th>
                        <th>Student ID</th>
                        <th>Final Accepted Status</th>
                        <th>University Name</th>
                        <th>Course Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {uniWiseport?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{dayjs(item?.VISADATE).format("DD MMM YYYY")}</td>
                          <td>{item?.STDID}</td>
                          <td>{item?.STATUS}</td>
                          <td>{item?.UNIVERSITYNAME}</td>
                          <td>{item?.COURSENAME}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default VisaTable;
